import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Field, Form } from 'formik';
import { IonLoading, IonButton, IonList, IonText } from '@ionic/react';
import { InputField } from 'components/form';
import AppActions from 'redux/AppRedux';
import AuthActions, { AuthSelectors } from 'redux/AuthRedux';
import api_v2 from 'services/api_v2';
import schema from './schema';

const INITIAL_VALUES = {
  firstName: '',
  lastName: '',
  phone: '',
  password: '',
};

function SignupForm() {
  const dispatch = useDispatch();
  const signupData = useSelector(AuthSelectors.selectSignup);

  const handleSubmit = async ({ passwordConfirm, ...payload }, actions) => {
    try {
      const { token, user } = await api_v2().signup(payload);
      dispatch(AuthActions.setUser(user));
      dispatch(AuthActions.login(token));
    } catch (e) {
      dispatch(
        AppActions.setToast(
          e.message || 'There was problem signing up',
          'danger'
        )
      );
    }

    actions.setSubmitting(false);
  };

  INITIAL_VALUES.phone = signupData && signupData.phone ? signupData.phone : '';

  return (
    <Formik
      initialValues={INITIAL_VALUES}
      onSubmit={handleSubmit}
      validationSchema={schema}
    >
      {({ isSubmitting, errors, values }) => {
        return (
          <Form>
            <IonLoading isOpen={isSubmitting} message="Loading..." />
            <IonList>
              <Field
                strongLabel
                component={InputField}
                name="phone"
                type="tel"
                label="Phone"
                placeholder="XXXXXXXXXX"
                disabled
              />
              <br />
              <Field
                strongLabel
                component={InputField}
                name="firstName"
                label="First Name"
                autoCapitalize="on"
              />
              <br />
              <Field
                strongLabel
                component={InputField}
                name="lastName"
                label="Last Name"
                autoCapitalize="on"
              />
              <br />
              <Field
                strongLabel
                component={InputField}
                name="password"
                type="password"
                label="Password"
              />
              <IonText color="medium" className="mb-2x">
                <small>Password must contain 6 digits</small>
              </IonText>
              <div className="mb-2x mt-5x text-center">
                <IonButton
                  className="sign-btn"
                  color="tertiary"
                  fill="solid"
                  type="submit"
                  disabled={
                    isSubmitting ||
                    errors.firstName ||
                    errors.lastName ||
                    errors.password ||
                    errors.phone
                  }
                >
                  Sign Up
                </IonButton>
              </div>
            </IonList>
          </Form>
        );
      }}
    </Formik>
  );
}

export default SignupForm;
